module.exports = __webpack_public_path__ + "img/c17.3a62137b.png";